var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportXar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 1.5C3.3335 0.947715 3.78121 0.5 4.3335 0.5H16.0002C16.2654 0.5 16.5197 0.605357 16.7073 0.792893L21.3739 5.45956C21.5615 5.6471 21.6668 5.90145 21.6668 6.16667V22.5C21.6668 23.0523 21.2191 23.5 20.6668 23.5H4.3335C3.78121 23.5 3.3335 23.0523 3.3335 22.5V1.5ZM5.3335 2.5V21.5H19.6668V7.16667H16.0002C15.4479 7.16667 15.0002 6.71895 15.0002 6.16667V2.5H5.3335Z",
    fill: "#323946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 17C17.5524 17 18.0001 17.4477 18.0001 18C18.0001 18.5523 17.5524 19 17.0001 19H8.00011C7.44782 19 7.00011 18.5523 7.00011 18C7.00011 17.4477 7.44782 17 8.00011 17H17.0001ZM14.0001 13C14.5524 13 15.0001 13.4477 15.0001 14C15.0001 14.5523 14.5524 15 14.0001 15H8.00011C7.44782 15 7.00011 14.5523 7.00011 14C7.00011 13.4477 7.44782 13 8.00011 13H14.0001ZM17.0001 9C17.5524 9 18.0001 9.44771 18.0001 10C18.0001 10.5523 17.5524 11 17.0001 11H8.00011C7.44782 11 7.00011 10.5523 7.00011 10C7.00011 9.44771 7.44782 9 8.00011 9H17.0001Z",
    fill: "#323946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportXar);
export default __webpack_public_path__ + "static/media/report-XAR.90375f593ecf87bed02da3b7f2e6f1a5.svg";
export { ForwardRef as ReactComponent };